import {OfferType} from "../../offer/types/OfferType";
import {IPropertyFaqItem, PropertyFaqQuestionKey} from "../types/IPropertyFaq";

export const PROPERTY_FAQ_THINKING_MESSAGE = "Analizujemy pytanie i przygotowujemy odpowiedź…";
export const PROPERTY_FAQ_SERVER_ERROR_MESSAGE = "Nie udało się teraz przygotować odpowiedzi. Spróbuj ponownie za chwilę.";
export const PROPERTY_FAQ_AI_DISCLAIMER = "Do wygenerowania tego opisu użyliśmy sztucznej inteligencji.";

const createQuestion = (questionKey: PropertyFaqQuestionKey, question: string): IPropertyFaqItem => ({
    id: questionKey,
    questionKey,
    question
});

const commuteQuestion: IPropertyFaqItem = {
    id: "commute",
    question: "Jak daleko będę mieć do pracy?",
    kind: "commute"
};

const flatQuestions: IPropertyFaqItem[] = [
    createQuestion("good_price", "Czy to mieszkanie jest w dobrej cenie?"),
    createQuestion("basic_surroundings", "Co znajduje się w okolicy mieszkania?"),
    commuteQuestion,
    createQuestion("quarters_lighting", "Jaka jest ekspozycja mieszkania? Czy będzie odpowiednio doświetlone?")
];

const familyQuestion = createQuestion("good_for_family", "Czy jest to dobra lokalizacja dla rodziny?");

const houseQuestions: IPropertyFaqItem[] = [
    createQuestion("good_price", "Czy ten dom jest w dobrej cenie?"),
    createQuestion("basic_surroundings", "Co znajduje się w okolicy domu?"),
    commuteQuestion,
    familyQuestion
];

interface IGetPropertyFaqQuestionsParams {
    offerType: number;
    rooms: number;
}

export const getPropertyFaqQuestions = ({offerType, rooms}: IGetPropertyFaqQuestionsParams): IPropertyFaqItem[] => {
    if (offerType === OfferType.HOUSE || offerType === OfferType.MODULAR_HOUSE) {
        return [...houseQuestions];
    }

    if (offerType === OfferType.FLAT && rooms >= 1) {
        return rooms >= 3 ? [...flatQuestions, familyQuestion] : [...flatQuestions];
    }

    return [];
};
import {OfferType} from "../../offer/types/OfferType";
import {IPropertyFaqItem, PropertyFaqQuestionKey} from "../types/IPropertyFaq";

export const PROPERTY_FAQ_THINKING_MESSAGE = "Analizujemy pytanie i przygotowujemy odpowiedź…";
export const PROPERTY_FAQ_SERVER_ERROR_MESSAGE = "Nie udało się teraz przygotować odpowiedzi. Spróbuj ponownie za chwilę.";
export const PROPERTY_FAQ_AI_DISCLAIMER = "Do wygenerowania tego opisu użyliśmy sztucznej inteligencji.";

const createQuestion = (questionKey: PropertyFaqQuestionKey, question: string): IPropertyFaqItem => ({
    id: questionKey,
    questionKey,
    question
});

const commuteQuestion: IPropertyFaqItem = {
    id: "commute",
    question: "Jak daleko będę mieć do pracy?",
    kind: "commute"
};

const flatQuestions: IPropertyFaqItem[] = [
    createQuestion("good_price", "Czy to mieszkanie jest w dobrej cenie?"),
    createQuestion("basic_surroundings", "Co znajduje się w okolicy mieszkania?"),
    commuteQuestion,
    createQuestion("quarters_lighting", "Jaka jest ekspozycja mieszkania? Czy będzie odpowiednio doświetlone?")
];

const familyQuestion = createQuestion("good_for_family", "Czy jest to dobra lokalizacja dla rodziny?");

const houseQuestions: IPropertyFaqItem[] = [
    createQuestion("good_price", "Czy ten dom jest w dobrej cenie?"),
    createQuestion("basic_surroundings", "Co znajduje się w okolicy domu?"),
    commuteQuestion,
    familyQuestion
];

interface IGetPropertyFaqQuestionsParams {
    offerType: number;
    rooms: number;
}

export const getPropertyFaqQuestions = ({offerType, rooms}: IGetPropertyFaqQuestionsParams): IPropertyFaqItem[] => {
    if (offerType === OfferType.HOUSE || offerType === OfferType.MODULAR_HOUSE) {
        return [...houseQuestions];
    }

    if (offerType === OfferType.FLAT && rooms >= 1) {
        return rooms >= 3 ? [...flatQuestions, familyQuestion] : [...flatQuestions];
    }

    return [];
};
